import { StandardEvents } from '@shopify/events';

class SwGoldenHour extends HTMLElement {
  #timer = null;
  #section = null;
  #selectionGeneration = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
    document.addEventListener('visibilitychange', this.#onClockResumed);
    window.addEventListener('pageshow', this.#onClockResumed);
    this.#startTimer();
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    document.removeEventListener('visibilitychange', this.#onClockResumed);
    window.removeEventListener('pageshow', this.#onClockResumed);
    this.#section = null;
    this.#stopTimer();
  }

  #stopTimer() {
    if (this.#timer !== null) {
      window.clearTimeout(this.#timer);
      this.#timer = null;
    }
  }

  #startTimer() {
    this.#stopTimer();
    this.#renderTime();
    if (!this.isConnected || document.hidden || this.hidden || !this.querySelector('[data-sw-clock]')) return;
    const delay = 1000 - (Date.now() % 1000) + 12;
    this.#timer = window.setTimeout(() => this.#startTimer(), delay);
  }

  #renderTime() {
    const clock = this.querySelector('[data-sw-clock]');
    if (!clock || this.hidden) return;
    const secondsUntilNextHour = 3600 - (Math.floor(Date.now() / 1000) % 3600);
    const hours = Math.floor(secondsUntilNextHour / 3600);
    const minutes = Math.floor((secondsUntilNextHour % 3600) / 60);
    const seconds = secondsUntilNextHour % 60;
    clock.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
    clock.setAttribute('datetime', 'PT' + secondsUntilNextHour + 'S');
  }

  #onClockResumed = () => {
    this.#startTimer();
  };

  #onProductSelect = event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise || typeof event.promise.then !== 'function') return;

    const generation = ++this.#selectionGeneration;
    this.hidden = true;
    this.#stopTimer();

    event.promise.then(({ detail }) => {
      if (generation !== this.#selectionGeneration || !this.isConnected || !detail?.html) return;
      if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.swProduct) return;

      const escapedId = CSS.escape(this.dataset.swBlock || '');
      const updated = detail.html.querySelector('sw-golden-hour[data-sw-block="' + escapedId + '"]');
      if (!updated) return;

      this.innerHTML = updated.innerHTML;
      this.hidden = updated.hidden;
      this.dataset.swProduct = updated.dataset.swProduct || '';
      this.#startTimer();
    }).catch(error => {
      if (generation !== this.#selectionGeneration || !this.isConnected) return;
      if (error?.name !== 'AbortError') console.warn('[sw-golden-hour] Variant update failed:', error);
    });
  };
}

if (!customElements.get('sw-golden-hour')) customElements.define('sw-golden-hour', SwGoldenHour);
